import React from "react";
import { Paragraph } from "@purpur/paragraph";
import c from "classnames/bind";

import styles from "./card-overline.module.scss";

const cx = c.bind(styles);

export type CardOverlineProps = {
  /**
   * Use this to set a testid on the overline
   */
  ["data-testid"]?: string;
  /**
   * The text displayed in the overline
   */
  overline?: string;
};

const rootClassName = "purpur-card-overline";

export const CardOverline = ({
  ["data-testid"]: dataTestId = "purpur-card-overline",
  overline,
}: CardOverlineProps) => {
  return overline ? (
    <Paragraph variant="overline-100" className={cx(rootClassName)} data-testid={dataTestId}>
      {overline}
    </Paragraph>
  ) : null;
};
